import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import { getComponentClasses } from '@99designs/utils/app';

export const SAVE_STATES = ['saving', 'saved', 'error'];

export default class SaveIndicator extends React.Component {
    componentWillUpdate(props) {
        if (props.state == 'saved' && props.onSavedComplete) {
            window.setTimeout(() => this.props.onSavedComplete(), props.savedStateTimeout);
        }
    }

    renderStateSaving() {
        return (
            <span className={getComponentClasses('save-indicator', ['saving'])}>
                <FormattedMessage id="save_indicator_saving" />
            </span>
        );
    }

    renderStateSaved() {
        return (
            <span className={getComponentClasses('save-indicator', ['saved'])}>
                <FormattedMessage id="save_indicator_saved" />
            </span>
        );
    }

    renderStateError() {
        return (
            <span className={getComponentClasses('save-indicator', ['error'])}>
                <button
                    className="button button--link link link--rising-sun"
                    onClick={this.props.onRetry}
                >
                    <FormattedMessage id="save_indicator_retry_save" />
                </button>
            </span>
        );
    }

    render() {
        switch (this.props.state) {
            case 'saving':
                return this.renderStateSaving();
            case 'saved':
                return this.renderStateSaved();
            case 'error':
                return this.renderStateError();
            default:
                return null;
        }
    }
}
SaveIndicator.propTypes = {
    state: PropTypes.oneOf(SAVE_STATES),
    onRetry: PropTypes.func,
    savedStateTimeout: PropTypes.number,
    onSavedComplete: PropTypes.func,
};
SaveIndicator.defaultProps = {
    state: null,
    onRetry: null,
    savedStateTimeout: 3000,
    onSavedComplete: null,
};



// WEBPACK FOOTER //
// ./src/web/js/contest/components/save-indicator.jsx